import React from 'react';
import { Link } from 'react-router-dom';
import Seo, { breadcrumbSchema, faqSchema } from '@/components/Seo';
import Breadcrumbs from '@/components/Breadcrumbs';
import Reveal from '@/components/Reveal';
import CTAPanel from '@/components/CTAPanel';
import { FAQS } from '@/data/siteData';

const Faqs = () => (
  <>
    <Seo
      title="Provident Palm Vista FAQs | Configurations, Price, RERA & Location"
      description="Frequently asked questions about Provident Palm Vista Shilphata — configurations, balconies, amenities, nearby schools & hospitals, RERA numbers, brochure, pricing and site visits."
      path="/faqs"
      jsonLd={[breadcrumbSchema([{ name: 'Home', path: '/' }, { name: 'FAQs', path: '/faqs' }]), faqSchema(FAQS)]}
    />
    <section className="pt-28 md:pt-36 pb-16 md:pb-24 bg-ivory min-h-[70vh]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <Breadcrumbs items={[{ name: 'FAQs' }]} />
        <Reveal>
          <p className="text-xs font-semibold tracking-[0.25em] uppercase text-gold">Help Centre</p>
          <h1 className="font-display text-4xl sm:text-5xl font-medium text-palm mt-3 leading-[1.08] tracking-tight">
            Provident Palm Vista – Frequently Asked Questions
          </h1>
          <p className="text-[15px] text-ink/75 mt-5 leading-relaxed">
            Answers based on official project material. For anything not covered here, reach us on WhatsApp or call +91 88798 56585.
          </p>
        </Reveal>

        <div className="space-y-3 mt-10" data-testid="faq-list">
          {FAQS.map((f, i) => (
            <Reveal key={f.q} delay={Math.min(i * 0.03, 0.3)}>
              <details className="group bg-white border border-line rounded-2xl px-6 py-4 open:shadow-md transition-shadow" data-testid={`faq-item-${i}`}>
                <summary className="flex items-center justify-between gap-4 cursor-pointer list-none font-semibold text-palm text-sm sm:text-base">
                  {f.q}
                  <span className="text-gold text-xl font-light group-open:rotate-45 transition-transform shrink-0">+</span>
                </summary>
                <p className="text-sm text-muted-foreground mt-3 leading-relaxed">{f.a}</p>
              </details>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-10 text-sm text-muted-foreground">
          Still have a question? <Link to="/contact" className="font-semibold text-palm hover:text-gold transition-colors">Contact our team</Link> — we respond quickly on WhatsApp.
        </Reveal>
      </div>
    </section>
    <CTAPanel />
  </>
);

export default Faqs;
